import React from "react";
import DashboardLayout from "../../../layouts/Dashboard";
import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const FactorList = () => {
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="factor"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    );
};

export default FactorList;
